import type { OvpClient } from '@bldsoft/cappie/api/ovp'
import type { API } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'
import { payload } from '../../result'

export function use(
  client: OvpClient,
  seo: API['seo'],
  _api: API,
  _defaults: AdapterDefaults
): void {
  // POST /api/web/analytics/meta/capi/events
  seo.base.trackEventFx.use(async (params) => {
    payload(
      await client.request.post('/api/web/analytics/meta/capi/events', {
        body: params,
      })
    )
  })

  // POST /api/web/leads
  seo.base.emailSubscribeFx.use(async (body) => {
    payload(await client.post.api.web.leads({ body }))
  })

  // GET /api/web/email-capture/confirm?token=
  seo.base.confirmEmailCaptureFx.use(async ({ token }) => {
    payload(
      await client.request.get('/api/web/email-capture/confirm', {
        query: { token },
      })
    )
  })
}
